import { optionSchema } from "@/common/schemas/option.schema";
import z from "zod";

export const maintenanceSpecialtySchema = z.object({
  system_part: optionSchema,
  part: optionSchema,
  action: optionSchema,
});

export type MaintenanceSpecialtyValidationSchema = z.infer<typeof maintenanceSpecialtySchema>;
